export default "__VITE_ASSET__Cw9m8UM$__"